/**
 * @author wxw
 * 模块说明：小项目管理
 */

import { Service } from '@/tools'

export class SmallDirectoryService<T extends TOrder.SmallDirectory> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.SmallDirectory}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  private get2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.SmallDirectory}`, data?: TCommon.Json, toast?: string) {
    return this.get(url, data, toast)
  }

  /**
   * 功能：分批查询小目录列表
   * /api/xxxxx
   */
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

  /**
   * 功能：小目录下发
   * /api/xxxxx
   */
  issued = <K extends T['ApiIssued']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiIssued', data)

  /**
   * 功能：小目录解锁
   * /api/xxxxx
   */
  directorySmallUnLock = <K extends T['ApiDirectorySmallUnLock']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDirectorySmallUnLock', data)

  /**
   * 功能：小目录锁定
   * /api/xxxxx
   */
  directorySmallLock = <K extends T['ApiDirectorySmallLock']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDirectorySmallLock', data)

  /**
   * 功能：根据小目录id查询大目录信息和小目录信息
   * /api/xxxxx
   */
  directorySmallEditInfo = <K extends T['ApiDirectorySmallEditInfo']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiDirectorySmallEditInfo', data)

  /**
   * 功能：小目录存草稿
   * /api/xxxxx
   */
  directorySmallDraft = <K extends T['ApiDirectorySmallDraft']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDirectorySmallDraft', data)

  /**
   * 功能：小目录详情
   * /api/xxxxx
   */
  directorySmallDetail = <K extends T['ApiDirectorySmallDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDirectorySmallDetail', data)

  /**
   * 功能：小目录提交
   * /api/xxxxx
   */
  directorySmallCommit = <K extends T['ApiDirectorySmallCommit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDirectorySmallCommit', data)

    /**
   * 功能：小目录再编提交
   * /api/xxxxx
   */
  againEditCommit = <K extends T['ApiAgainEditCommit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAgainEditCommit', data)

  /**
   * 功能：删除小目录
   * /api/xxxxx
   */
  deleteDirectorySmall = <K extends T['ApiDeleteDirectorySmall']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteDirectorySmall', data)

  /**
   * 功能：撤销发布
   * /api/xxxxx
   */
  CancelIssued = <K extends T['ApiCancelIssued']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCancelIssued', data)

  /**
   * 功能：新增小目录
   * /api/xxxxx
   */
  addDirectorySmall = <K extends T['ApiAddDirectorySmall']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddDirectorySmall', data)
  /**
   * 功能：查询小目录列表下拉框
   * /api/xxxxx
   */
  smallDirectoryDropDown = <K extends T['ApiSmallDirectoryDropDown']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSmallDirectoryDropDown', data)
   /**
   * 功能：查询小目录列表下拉框 新加的
   * /api/xxxxx
   */
   smallDirectory = <K extends T['ApiSmallDirectory']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSmallDirectory', data)

  /**
   * 功能：查询小目录列表下拉框分页模糊搜索
   * /api/xxxxx
   */
  smallDirectoryDropDownPage = <K extends T['ApiSmallDirectoryDropDownPage']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSmallDirectoryDropDownPage', data)
  /**
   * 功能：根据小目录id查询商品列表
   * /api/xxxxx
   */
  selectBooksBySmallId = <K extends T['ApiSelectBooksBySmallId']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSelectBooksBySmallId', data)

  /**
   * 功能：撤销发布-新
   * /api/xxxxx
   */
  smallCancelIssued = <K extends T['ApiSmallCancelIssued']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSmallCancelIssued', data)

 /**
   * 功能：小目录下发-批量新
   * /api/xxxxx
   */
  smallBatchIssued = <K extends T['ApiSmallBatchIssued']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSmallBatchIssued', data)
/**
   * 功能：撤销发布-批量新
   * /api/xxxxx
   */
  smallBatchCancelIssued = <K extends T['ApiSmallBatchCancelIssued']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSmallBatchCancelIssued', data)
/**
   * 功能：下发明细-小目录详情
   * /api/xxxxx
   */
  issuedInfo = <K extends T['ApiIssuedInfo']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiIssuedInfo', data)
/**
   * 功能：下发明细-基层店信息分页
   * /api/xxxxx
   */
  issuedInfoPage = <K extends T['ApiIssuedInfoPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiIssuedInfoPage', data)
/**
   * 功能：小目录重新发-新
   * /api/xxxxx
   */
  smallIssued = <K extends T['ApiSmallIssued']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSmallIssued', data)

  /**
   *查询小目录列表下拉框分页-新
   * /api/order/smallDirectory/v1/smallDropDownPage
   */
  smallDropDownPage = <K extends T['ApiSmallDropDownPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSmallDropDownPage', data)

}
